import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const setupFrontQuote = (el) => {
  const mediaEl = el.querySelector('[data-media]')

  gsap.to(mediaEl, {
    scrollTrigger: {
      trigger: mediaEl,
      start: 'top bottom',
      endTrigger: mediaEl,
      end: 'bottom top',
      scrub: true,
    },
    yPercent: -15,
  })
}

export default setupFrontQuote
